import { Link } from "react-router-dom";
import { Ban, Flag, ScrollText, Timer } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Flag,
    title: "Report any user or message",
    body: "Reporting tools live on every profile and in every chat. Reports are always confidential.",
  },
  {
    icon: Ban,
    title: "Block & unmatch instantly",
    body: "Blocked members disappear from Discover, Matches and messaging. Unmatch quietly, anytime.",
  },
  {
    icon: Timer,
    title: "Moderation within 24 hours",
    body: "Every report is reviewed by a human. Violating content or accounts are removed, fast.",
  },
  {
    icon: ScrollText,
    title: "Clear community rules",
    body: "Our Community Guidelines and Safety Tips set the standard everyone agrees to.",
    links: true,
  },
];

export const Safety = () => (
  <section id="safety" data-testid="safety-section" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
    <Reveal className="max-w-2xl">
      <Eyebrow>Trust & safety</Eyebrow>
      <h2 className="mt-5 font-editorial text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
        A respectful community,{" "}
        <span className="font-normal italic text-terracotta-dark">by design</span>
      </h2>
      <p className="mt-5 text-base leading-relaxed text-clay sm:text-lg">
        STETH has a zero-tolerance policy for objectionable content and abusive
        behavior, and the tools to back it up.
      </p>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2">
      {ITEMS.map((it, i) => (
        <Reveal key={it.title} delay={i * 0.08}>
          <div
            data-testid={`safety-item-${i}`}
            className="group flex h-full gap-5 rounded-[24px] border border-hairline bg-cream p-7 transition-colors duration-300 hover:border-sage/50 hover:bg-[#F4F8F5]"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#E9F1EC] text-sage transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
              <it.icon size={22} />
            </div>
            <div>
              <h3 className="text-lg font-extrabold tracking-tight">{it.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-clay">{it.body}</p>
              {it.links && (
                <div className="mt-3 flex flex-wrap gap-4">
                  <Link to="/guidelines" data-testid="safety-guidelines-link" className="text-sm font-bold text-terracotta hover:text-terracotta-dark">
                    Community Guidelines
                  </Link>
                  <Link to="/safety" data-testid="safety-tips-link" className="text-sm font-bold text-terracotta hover:text-terracotta-dark">
                    Dating Safety Tips
                  </Link>
                </div>
              )}
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
